document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("trabajaForm");
    const submitBtn = document.getElementById("submitBtn");
    const successMessage = document.getElementById("successMessage");
    const errorMessage = document.getElementById("errorMessage");

 
		if( form ) {

			form.addEventListener("input", function () {
					submitBtn.disabled = !form.checkValidity();

					successMessage.style.display = 'none';
					errorMessage.style.display = 'none';
			});

			// Manejar el envío del formulario
			form.addEventListener("submit", async function (e) {
					e.preventDefault();
					
					if (form.submitting) return;

					try {
							form.submitting = true;
							submitBtn.disabled = true;
							submitBtn.textContent = 'Enviando...';

							const formData = new FormData(form);
							
							const response = await fetch('/enviar-formulario', {
									method: 'POST',
									body: formData,
									headers: {
										'X-Requested-With': 'XMLHttpRequest',
										'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
									},
							});

							if (response.status === 429) {
									form.style.display = 'block';
									errorMessage.style.display = 'block';
									successMessage.style.display = 'none';
									return;
							}

							if (response.ok) {
									const data = await response.json();
									if (data.success) {
											form.style.display = 'none';
											successMessage.style.display = 'block';
											form.reset();
									}
							}
					} catch (error) {
							console.error('Error:', error);
							errorMessage.textContent = 'Ha ocurrido un error. Por favor, inténtalo de nuevo.';
							errorMessage.style.display = 'block';
					} finally {
							submitBtn.textContent = 'Enviar';
							form.submitting = false;
							submitBtn.disabled = false;
					}
			});

		}
		
});